import { CardsLkItem } from '../../contracts/CardsLk'

export const isCabinetClickable = (item: CardsLkItem): boolean =>
  Boolean(item.url) && item.action !== null
